<template>
  <div class="splash-screen">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center" class="fill-height">
        <v-col cols="12" sm="8" md="4" class="text-center">
          <v-icon size="100" color="primary" class="mb-4">mdi-shield-check</v-icon>
          <h1 class="text-h3 font-weight-bold mb-2">CoachSight</h1>
          <p class="text-body1 text-medium-emphasis mb-8">{{ t('app.loading') }}</p>
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
          <p class="text-caption text-medium-emphasis mt-6">{{ displayMessage }}</p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

interface Props {
  message?: string
}

const props = defineProps<Props>()
const { t } = useI18n()
const displayMessage = computed(() => props.message || t('app.session.initializing'))

</script>

<style scoped>
.splash-screen {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
